<template>
  <Transition name="toast">
    <div v-if="show" class="toast-container">
      <div class="toast-content">
        <i class="fa-solid fa-radio toast-icon"></i>
        <div class="toast-text">
          <p class="toast-message">{{ message }}</p>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { watch } from 'vue';

const props = defineProps({
  message: {
    type: String,
    default: ''
  },
  show: {
    type: Boolean,
    default: false
  },
  duration: {
    type: Number,
    default: 3000
  }
});

const emit = defineEmits(['close']);

let timeoutId = null;

watch(() => props.show, (newVal) => {
  if (newVal) {
    // Limpiar timeout anterior si existe
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Auto-cerrar después de la duración
    timeoutId = setTimeout(() => {
      emit('close');
    }, props.duration);
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/astra-vars.scss";

.toast-container {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9999;
  pointer-events: none;
}

.toast-content {
  display: flex;
  align-items: center;
  gap: $s12;
  padding: $s14 $s18;
  background: var(--bg-cards);
  border: 1px solid var(--border);
  border-radius: 0;
  backdrop-filter: blur(15px);
  pointer-events: auto;
  min-width: 280px;
  max-width: 400px;
}

.toast-icon {
  font-size: 1.25rem;
  color: var(--accent-color);
  flex-shrink: 0;
}

.toast-text {
  flex: 1;
}

.toast-message {
  margin: 0;
  font-size: 0.938rem;
  font-weight: 500;
  color: var(--text-color);
  line-height: 1.4;
}

/* Transiciones */
.toast-enter-active {
  transition: all 0.3s ease;
}

.toast-leave-active {
  transition: all 0.2s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.toast-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* Responsive */
@media (max-width: 768px) {
  .toast-container {
    top: 70px;
    right: 10px;
    left: 10px;
  }

  .toast-content {
    min-width: auto;
    max-width: 100%;
  }
}
</style>
